import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNativeBanner = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 35,
			height: 35,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.27295,
			width: 36,
			height: .818182,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 7,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 24,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 31,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 27,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 10.5,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 14,
			width: 30,
			height: 8,
			rx: 1,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19,
			y: 17.4136,
			width: 13,
			height: 3.41333,
			rx: 1,
			fill: "white"
		})
	]
});
export default SvgNativeBanner;
